// extracted by mini-css-extract-plugin
export default {"item":"ServiceItem_item__lCH2w","img":"ServiceItem_img__1W7qP","name":"ServiceItem_name__h063J","desc":"ServiceItem_desc__Sz4QM","imgEmpty":"ServiceItem_imgEmpty__w-r89"};